import React from "react";
import {
  FieldPath,
  FieldValues,
  PathValue,
  useController,
  useFormContext,
} from "react-hook-form";

import { BaseFieldProps } from "./FieldProps";
import ToggleGroup, { ToggleOptions } from "./ToggleGroup";
import useIsFieldDisabled from "../../hooks/formHooks/useIsFieldDisabled";

type Props<TFieldValues extends FieldValues> = {
  options: ToggleOptions;
  exclusive?: boolean;
} & BaseFieldProps<TFieldValues>;

const ToggleField = <TFieldValues extends FieldValues>({
  name,
  options,
  exclusive,
  disabled = false,
  disabledForEdit = false,
}: Props<TFieldValues>) => {
  const { control, clearErrors } = useFormContext<TFieldValues>();
  const { field, fieldState } = useController({
    name,
    control,
  });

  const errorMessage = fieldState.error?.message;
  const isFieldDisabled = useIsFieldDisabled(disabled, disabledForEdit);

  const handleToggle = (
    e: React.MouseEvent<HTMLElement>,
    newToggles: PathValue<TFieldValues, FieldPath<TFieldValues>>,
  ) => {
    field.onChange(newToggles);
    clearErrors(field.name);
  };

  return (
    <ToggleGroup
      onChange={handleToggle}
      value={field.value}
      options={options}
      exclusive={exclusive}
      errorMessage={errorMessage}
      disabled={isFieldDisabled}
    />
  );
};

export default ToggleField;
